<template>
  <div>
    <div class="wrap satisfaction-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>만족도</h3>
      </div>
      <div class="body-wrap">
        <h4>
          이번 코칭은 어떠셨나요?
          <span>만족도를 입력하시면 코멘트 확인이 가능합니다</span>
        </h4>
        <!-- <p></p> -->
        <div v-for="(item, index) in survey" class="question" :key="index">
          <p class="bold">
            {{ item.survey_content }}
          </p>
          <ul>
            <li v-for="(subItem, subIndex) in item.survey_quesion" :class="{ active: subItem == item.survey_answer }" :key="subIndex" @click="surveyCheck(index, subItem)">{{ subItem }}</li>
          </ul>
        </div>
      </div>
      <div class="bnb-btn">
        <button class="active" @click="save()">Next</button>
        <p @click="next()">다음에 할게요!</p>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "satisfaction",
  props: {
    idx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    survey: [
      {
        survey_content: "1. 전반적인 코칭 내용에 만족한다.",
        survey_quesion: [1, 2, 3, 4, 5],
        survey_answer: 0,
      },
      {
        survey_content: "2. 코칭의 목표와 부합하게 진행되었다.",
        survey_quesion: [1, 2, 3, 4, 5],
        survey_answer: 0,
      },
      {
        survey_content: "3. 코치의 코치 진행과 코치 방식에 만족한다.",
        survey_quesion: [1, 2, 3, 4, 5],
        survey_answer: 0,
      },
    ],
    input: {
      courseIdx: 0,
      idxTbUser: 75,
      satScore: 0,
    },
  }),
  components: {
    incBack,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    surveyCheck(index, subIndex) {
      this.survey[index].survey_answer = subIndex;
    },
    save() {
      for (let i = 0; i < this.survey.length; i++) {
        if (this.survey[i].survey_answer == 0) {
          alert("모든 항목에 체크해주세요.");
          return false;
        }
      }
      console.log(this.survey);

      let form = new FormData();
      form.append("sessionIdx", this.idx);
      form.append("qna1Score", this.survey[0].survey_answer);
      form.append("qna2Score", this.survey[1].survey_answer);
      form.append("qna3Score", this.survey[2].survey_answer);

      this.axios
        .post("/front/coarching/complete/satisfied/save", form)
        .then((res) => {
          if (res.data.success) {
            alert("감사합니다! 더욱 좋은 코칭 서비스를 위해 노력하겠습니다!");
            this.$router.push({ name: "coach_comment", params: { idx: this.idx } });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // this.input.courseIdx = this.idx;
      // this.input.satScore = String(this.survey[0].survey_answer);

      // let form = new FormData();
      // for(const [key,value] of Object.entries(this.input)){
      //     form.append(key,value)
      // }
      // this.axios.post("/front/coarching/complete/satisfied/save",form).then((res)=>{
      //     // console.log(res);
      //     if(res.data.success){
      //         alert("감사합니다! 더욱 좋은 코칭 서비스를 위해 노력하겠습니다!");
      //         this.$router.push({name:"coach_comment",params:{idx:this.idx}});
      //     }
      // }).catch((err)=>{
      //     console.log(err);
      // });
      // alert("감사합니다! 더욱 좋은 코칭 서비스를 위해 노력하겠습니다!");
      // this.$router.push({name:"coach_comment",params:{idx:this.idx}});
    },
    next() {
      this.$router.push({ name: "coach_comment", params: { idx: this.idx } });
    },
  },
};
</script>
<style lang="scss" scoped>
.bnb-btn {
  text-align: center;
  width: 100%;
  position: relative;
  bottom: 150px;
}
</style>
